import { Module } from 'vuex'
import { RootState, AttachmentState } from 'surface/xstore/types'

const attachmentModule: Module<AttachmentState, RootState> = {
  namespaced: true,
  state: {
    fileUploadingToPickerBox: null,
  },
  getters: {
    fileUploadingToPickerBox: (state): any => state.fileUploadingToPickerBox,
  },
  mutations: {
    UPLOAD_FILE (state, file): void {
      state.fileUploadingToPickerBox = file
    },
    COMPLETE_UPLOAD_FILE (state): void {
      state.fileUploadingToPickerBox = null
    },
    CANCEL_UPLOAD_FILE (state): void {
      state.fileUploadingToPickerBox = null
    },
  },
  actions: {
    uploadFileToPickerBox ({ commit }, { file }): void {
      commit('UPLOAD_FILE', file)
    },
    completeUploadingFileToPickerBox ({ commit }): void {
      commit('COMPLETE_UPLOAD_FILE')
    },
    cancelUploadFileToPickerBox ({ commit }): void {
      commit('CANCEL_UPLOAD_FILE')
    },
  },
}

export default attachmentModule
